import React from 'react'
import {
  //REGION_COUNTRIES,
  INCOME_GROUPS,
  UNI_REGIONS,
  WHO_REGIONS,
  REGION_LOOKUP
} from '../utils/const'
import styled from 'styled-components'
import { MediaQueries as Mq } from '../styles/MediaQueries'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql } from 'gatsby'

const CountryList = styled.div`
  color: var(--darkGray);
  column-count: ${(props) => props.cols};
  ${Mq.md} {
    column-count: 2;
  }
`

const NUM_COLS = {
  AFR: 4,
  EMR: 2,
  EUR: 4,
  SEAR: 1,
  AMR: 2,
  WPR: 2,

  ROSA: 1,
  MENA: 1,
  ECAR: 2,
  LACR: 3,
  ESAR: 2,
  WCAR: 2,
  EAPR: 2,

  WBHIC: 3,
  WBLIC: 2,
  WBUMIC: 4,
  WBLMIC: 4
}
const RegionList = ({ reg }) => {
  const { t } = useTranslation()

  //picking a random indicator here -- just need to get the countries
  const { rows } = useStaticQuery(graphql`
    query {
      rows: allCountries(filter: { IA2030_IND: { eq: "IG3.2" } }) {
        nodes {
          COUNTRY
          COUNTRY_NAME
          WHO_REGION
          UNICEF_REGION
          WB_INCOME_STATUS
        }
      }
    }
  `)

  //which group of countries do we need?
  const isInc = INCOME_GROUPS.includes(reg)
  const isUni = UNI_REGIONS.includes(reg)
  const isWho = WHO_REGIONS.includes(reg)
  //const isGbl = reg === 'GBL' || !reg

  //which countries are in this group?
  const filterData = (data) => {
    return isInc
      ? data.filter((d) => d.WB_INCOME_STATUS === REGION_LOOKUP[reg])
      : isUni
      ? data.filter((d) => d.UNICEF_REGION === REGION_LOOKUP[reg])
      : isWho
      ? data.filter((d) => d.WHO_REGION === REGION_LOOKUP[reg])
      : data
  }

  const countries = Array.from(
    new Set(filterData(rows.nodes).map((d) => d.COUNTRY_NAME))
  ).sort()

  return (
    <>
      <CountryList cols={NUM_COLS[reg]}>
        {countries.map((item) => (
          <p key={item}>{t(item)}</p>
        ))}
      </CountryList>
    </>
  )
}

export default RegionList
